// extracted by mini-css-extract-plugin
module.exports = {"fullScreenWrapper":"jgp-1Xn1q","contentWrapper":"jgp-3HYK5","button":"jgp-2Tui3"};